export default __webpack_public_path__ + "images/084c16fd8143b7750fb8a247a688b87b.svg";